export const triggerVibration = (duration = 100) => {
    if (navigator.vibrate) {
      navigator.vibrate(duration); // Vibrates for the given duration
    } else {
      console.log("Vibration API is not supported on this device.");
    }
  };
  
